import React from "react";
import {
  MdMailOutline,
  MdOutlineLocationCity,
  MdOutlineLocationOn,
} from "react-icons/md";
import { BsPhone } from "react-icons/bs";
import { Text } from "@mantine/core";
const Footer = () => {
  return (
    <>
      <section className=" container flex justify-center items-center mt-[4.2rem]">
        <Text className="text-center text-xl text-[#737373] border-b-yellow-500 border-b-2 w-[120px] mx-auto uppercase">
          Contact us
        </Text>
      </section>
      <div className=" flex flex-col justify-center items-center gap-7 mt-10 ">
        <div className="w-[300px] md:w-[400px] text-[#867985]">
          <div className="flex flex-row items-center gap-5  mb-4">
            <MdMailOutline />
            <p> Chaybeexclusive@gmail.com</p>
          </div>
          <div className="flex flex-row items-center gap-5 my-4 ">
            <BsPhone />
            <p> 09454944469</p>
          </div>
          <div className="flex flex-row items-center gap-5 ">
            <div>
              <MdOutlineLocationOn />
            </div>
            <p>
              No.4 U Ba Kyaw Street, Near Lay Daunt Kan Street Overpass
              Bridge,Tamwe Lay Township, YANGON.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
